module.exports = __webpack_public_path__ + "static/media/press_freicaneca.fde36cda.jpg";